// extracted by mini-css-extract-plugin
module.exports = {"text":"credits_text__TKfT7","link":"credits_link__8j6AW"};